import { useSelector } from 'react-redux'
import Loader from 'react-loaders'
import { useState } from 'react'
import { useFetchLogsByTable } from '../../../../Queries/Logs/useFetchLogsByTable'
import RefundCreateLog from './refundCreateLog'
import MoveBookingLog from './moveBookingLog'
import UpdateLog from './updateLogs'
import RefundApprove from './refundApprove'
import RefundRejected from './refundRejected'
import PaymentCreated from './created'
import PaymentUpdatedLog from './paymentUpdated'
import PaymentGenerated from './paymentGenerated'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import CreateBookingReservationLog from './createBookingReservationLog'
import TransactionFailed from './transactionFailed'
import MoveBookingMaintainanceLog from './moveBookingMaintainance'
import BookPupilPremiumLog from './bookPupilPremiumLog'
import UpdateUnitLog from './updateUnitLog'

const renderLog = (type, data, onExpand, expandedId, parentPageName) => {
  switch (type) {
    case 'create':
      return <PaymentCreated data={data} onExpand={onExpand} expandedId={expandedId}></PaymentCreated>
    case 'edit_purchase':
      return <PaymentUpdatedLog data={data} onExpand={onExpand} expandedId={expandedId}></PaymentUpdatedLog>
    case 'update':
      return <UpdateLog data={data} onExpand={onExpand} expandedId={expandedId} parentPageName={parentPageName}></UpdateLog>
    case 'payment_generated':
      return <PaymentGenerated data={data} onExpand={onExpand} expandedId={expandedId} parentPageName={parentPageName}></PaymentGenerated>
    case 'payment_completed':
      return (
        <PaymentGenerated
          data={data}
          onExpand={onExpand}
          expandedId={expandedId}
          parentPageName={parentPageName}
          isPaymentCompleted={true}></PaymentGenerated>
      )
    case 'refund_create':
      return <RefundCreateLog data={data} onExpand={onExpand} expandedId={expandedId}></RefundCreateLog>
    case 'refund_approve':
      return <RefundApprove data={data} onExpand={onExpand} expandedId={expandedId}></RefundApprove>
    case 'refund_reject':
      return <RefundRejected data={data} onExpand={onExpand} expandedId={expandedId}></RefundRejected>
    case 'move_booking':
      return <MoveBookingLog data={data} onExpand={onExpand} expandedId={expandedId}></MoveBookingLog>
    case 'maintenance_move_booking':
      return <MoveBookingMaintainanceLog data={data} onExpand={onExpand} expandedId={expandedId} />
    case 'create_booking_reservation':
      return <CreateBookingReservationLog data={data} onExpand={onExpand} expandedId={expandedId}></CreateBookingReservationLog>
    case 'transaction_failed':
      return <TransactionFailed data={data} onExpand={onExpand} expandedId={expandedId} />
    case 'booked_pupil_premium_locker':
      return <BookPupilPremiumLog data={data} onExpand={onExpand} expandedId={expandedId}></BookPupilPremiumLog>
    case 'update_unit_data':
      return <UpdateUnitLog data={data} onExpand={onExpand} expandedId={expandedId} />
    default:
      return
  }
}

const RefundLogs = ({ parentPageName }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  let role_id = currentRow?.[currentRow?.length - 1]?.uuid
  const [page, setPage] = useState()
  const { data, isLoading } = useFetchLogsByTable(role_id, 'payments', page)

  const [expandedId, setExpandedId] = useState()

  const onExpand = (id) => {
    setExpandedId(id)
  }

  if (!isLoading && data?.data?.length === 0)
    return (
      <div className='d-flex align-items-center justify-content-center' style={{ marginTop: '3rem' }}>
        <img src='not_found.png' style={{ width: '20rem' }}></img>
      </div>
    )
  if (data?.data?.length !== 0 && isLoading)
    return (
      <div style={{ display: 'flex', justifyContent: 'center', height: '10rem', alignItems: 'center' }}>
        <Loader type='ball-pulse' color='blue' />
      </div>
    )

  return (
    <div>
      <div style={{ minHeight: '55vh' }}>
        {' '}
        {data?.data?.map((item, index) => {
          if (!expandedId) {
            return (
              <div key={index} className='p-1'>
                {renderLog(item?.type, item, onExpand, null, parentPageName)}
              </div>
            )
          } else {
            if (expandedId === item?.id) {
              return (
                <div key={index} className='p-1'>
                  {renderLog(item?.type, item, onExpand, expandedId, parentPageName)}
                </div>
              )
            } else {
              return <></>
            }
          }
        })}
      </div>

      <div className='d-flex justify-content-center mt-4'>
        <Pagination aria-label='Page navigation example' style={{ flexWrap: 'wrap' }}>
          {data?.links?.map((item, key) => {
            return (
              <PaginationItem active={item.active} disabled={item.url === null} key={key}>
                <PaginationLink
                  first
                  className='subtitle2'
                  onClick={() => {
                    if (item?.label?.toLowerCase()?.includes('previous')) {
                      setPage(parseInt(data?.current_page) - 1)
                    } else if (item?.label?.toLowerCase()?.includes('next')) {
                      setPage(parseInt(data?.current_page) + 1)
                    } else {
                      setPage(parseInt(item?.label))
                    }
                  }}>
                  {item.label.replace('&laquo;', '').replace('&raquo;', '')}
                </PaginationLink>
              </PaginationItem>
            )
          })}
        </Pagination>
      </div>
    </div>
  )
}

export default RefundLogs
